module.exports = __webpack_public_path__ + "static/media/Poppy_0.5463940c.jpg";